import { render, staticRenderFns } from "./prizeDetails.vue?vue&type=template&id=30e5bb72&scoped=true"
import script from "./prizeDetails.vue?vue&type=script&lang=js"
export * from "./prizeDetails.vue?vue&type=script&lang=js"
import style0 from "./prizeDetails.vue?vue&type=style&index=0&id=30e5bb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e5bb72",
  null
  
)

export default component.exports